import { Paginator } from '@app/classes';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { AuthService } from '@app/services';
import {
    DepartmentColumn,
    FullNameColumn,
    PositionColumn,
    StatusColumn,
} from '@employees/services/tables/employee-table/columns';
import { Role } from '@models/account/role.model';
import { Employee } from '@models/employee/employee.model';
import { KYCStatusColumn } from './columns/kyc-status.column';

const revokeOption: MenuColumnItem = {
    label: 'settings.role-employees.revokeButton',
    event: 'revoke',
};

export class RoleEmployeesTable extends Table {
    showMenuColumnOptions = true;

    protected canControlRole = false;

    constructor(
        protected auth: AuthService,
        protected role: Role,
        private hasKYC: boolean
    ) {
        super(auth);
        this.boot();
        this.loadAssignableRoles();
    }

    setColumns(): void {
        const companyId = this.auth.company.id;

        this.addColumns(
            new FullNameColumn(),
            new PositionColumn(companyId),
            new DepartmentColumn(companyId),
            new StatusColumn()
        );

        if (this.hasKYC) {
            this.addColumns(new KYCStatusColumn());
        }
    }

    getMenuColumnOptionsForRow(_: Employee): MenuColumnItem<string>[] {
        if (!this.canControlRole) {
            return [];
        }

        return [revokeOption];
    }

    setDataSource(): void {
        const withClause = ['department', 'job'];
        // If the role doesn't have access to KYC then we don't need to return their account data as part of the table data
        if (this.hasKYC) {
            withClause.push('account');
        }
        this.paginator = new Paginator(
            Employee.param('company', this.auth.company.id).where('roleId', this.role.id).with(withClause)
        );
    }

    // only show the revoke option if the auth'd user has control this role
    private loadAssignableRoles(): void {
        Role.where('company_id', this.auth.company.id)
            .where('assignableBy', this.auth.role.id)
            .limit(0)
            .get()
            .then(([roles]) => {
                this.canControlRole = roles.some((role) => role.id === this.role.id);
            });
    }
}
